import type { CommandResultsColumn } from "../../components/command-results-modal.component";
import { CommandResultsModal } from "../../components/command-results-modal.component";
import type { DaylightProfileBackupRestoreData } from "../../components/types";

type DaylightProfileCommandResultsModalProps = {
  showModal: boolean;
  handleClose: () => void;
  isLoading: boolean;
  lastSyncDisplay: string;
  data: DaylightProfileBackupRestoreData | null;
  onBackup: () => void;
  onRestore: () => void;
  isRestoreMode?: boolean;
  errorMessage?: string | null;
};

export function DaylightProfileCommandResultsModal({
  showModal,
  handleClose,
  isLoading,
  lastSyncDisplay,
  data,
  onBackup,
  onRestore,
  isRestoreMode = false,
  errorMessage,
}: DaylightProfileCommandResultsModalProps) {
  const columns: CommandResultsColumn<any>[] = [
    { key: "parameterName", title: "Parameter" },
    {
      key: "currentValue",
      title: "Current",
      className: "gateway-config__value--current",
      render: (parameter: any) =>
        parameter.currentDisplayValue ?? parameter.currentValue ?? "--",
    },
    {
      key: "baselineValue",
      title: "Baseline",
      className: "gateway-config__value--baseline",
      render: (parameter: any) =>
        parameter.baselineDisplayValue ?? parameter.baselineValue ?? "--",
    },
  ];

  return (
    <CommandResultsModal
      showModal={showModal}
      handleClose={handleClose}
      isLoading={isLoading}
      lastSyncDisplay={lastSyncDisplay}
      data={data?.parameters ?? null}
      columns={columns}
      getRowKey={(parameter: any) => parameter.parameterId}
      onConfirm={isRestoreMode ? onRestore : onBackup}
      isRestoreMode={isRestoreMode}
      confirmLabel="Backup"
      restoreLabel="Restore"
      errorMessage={errorMessage}
      emptyMessage="No parameters returned from the device."
      successMessage="The requested configuration parameters have been successfully retrieved from the node."
      restoreMessage="Restoring the configuration will revert all current values to the baseline"
    />
  );
}
